import { __decorate, __metadata } from "tslib";
import { Type } from "class-transformer";
import { v4 as uuidv4 } from "uuid";
import { ActionItemModel } from "./actionItem";
import { ClientUpdateAttachmentModel } from "./clientUpdateAttachment";
let ClientUpdateModel = /** @class */ (() => {
    class ClientUpdateModel {
        constructor() {
            this.id = uuidv4();
            this.clientId = "";
            this.updateSideId = "";
            this.interactionTypeId = null;
            this.teamId = null;
            this.teamName = null;
            this.entryDate = null;
            this.updateHtml = "";
            this.isUpdatesOnly = false;
            this.createdOn = null;
            this.createdBy = null;
            this.createdByName = "";
            this.createdByImageURL = "";
            this.modifiedOn = null;
            this.modifiedBy = null;
            this.attachments = [];
            this.actionItems = [];
        }
    }
    __decorate([
        Type(() => ClientUpdateAttachmentModel),
        __metadata("design:type", Array)
    ], ClientUpdateModel.prototype, "attachments", void 0);
    __decorate([
        Type(() => ActionItemModel),
        __metadata("design:type", Array)
    ], ClientUpdateModel.prototype, "actionItems", void 0);
    return ClientUpdateModel;
})();
export { ClientUpdateModel };
export default class ClientUpdate extends ClientUpdateModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
